module.exports = "<input type=\"text\" class=\"form-control\" (keyup)=\"updateSearchInput($event)\" placeholder=\"Zoek op klantnaam\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/invoices/invoice-search/invoice-search.template.html
// module id = ./src/app/invoices/invoice-search/invoice-search.template.html
// module chunks = main